import { message } from 'antd';
import { AxiosError } from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

interface ApiErrorResponse {
    message: string;
    errors?: Record<string, string[]>;
}

export const useApiErrorHandler = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleError = (error: any, setFormErrors?: (errors: Record<string, string[]>) => void) => {
        if (error instanceof Error) {
            const axiosError = error as AxiosError<ApiErrorResponse>;
            
            // Handle unauthorized errors - redirect to login
            if (axiosError.response?.status === 401) {
                message.error('Session expired. Please login again.');
                logout();
                navigate('/login');
                return;
            }
            
            // Handle validation errors
            if (axiosError.response?.status === 422 && axiosError.response.data.errors && setFormErrors) {
                setFormErrors(axiosError.response.data.errors);
            }
            
            // Show error message
            const errorMessage = axiosError.response?.data?.message || axiosError.message;
            message.error(errorMessage);
        } else {
            message.error('An unexpected error occurred');
        }
    };

    return { handleError };
};
